import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AppRoleDto, PermissionDto, RolePermissionEnum, RolePermissionGroupEnum } from '../../service/dto';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpAppRoleService } from '../../service/http-app-role.service';

class RoleWrapper {
	roleId!: number;
	selected!: boolean;
}

class PermissionWrapper {
	permission!: RolePermissionEnum;
	label!: string;
	description?: string;
	roles!: RoleWrapper[];
}

class Section {
	label!: string;
	wrappers!: PermissionWrapper[];
}

@Component({
	selector: 'app-permission',
	standalone: false,
	templateUrl: './permission.component.html',
	styleUrl: './permission.component.scss'
})
export class PermissionComponent implements OnInit, OnDestroy {
	@Input() viewOnly = false;
	appRoles: AppRoleDto[] = [];
	// memberPermissions: PermissionWrapper[] = [];
	// agentPermissions: PermissionWrapper[] = [];
	// ticketPermissions: PermissionWrapper[] = [];
	// communicationPermissions: PermissionWrapper[] = [];
	// entityPermissions: PermissionWrapper[] = [];
	// configurationPermissions: PermissionWrapper[] = [];

	// bankDepositPermissions: PermissionWrapper[] = [];
	// policyPermissions: PermissionWrapper[] = [];
	// productPermissions: PermissionWrapper[] = [];
	// bulkUploadPermissions: PermissionWrapper[] = [];
	// verificationPermissions: PermissionWrapper[] = [];
	// notificationTemplatePermissions: PermissionWrapper[] = [];

	sections: Section[] = [];

	constructor(private service: HttpAppRoleService, private messageService: NzMessageService) { }

	ngOnInit(): void {
		this.service.getAll().subscribe(result => this.populate(result));
	}
	ngOnDestroy(): void {

	}
	private populate(input: AppRoleDto[]) {
		this.appRoles = input;
		this.sections = [];
		const distinctGroups = [...new Set(this.appRoles.flatMap(role => role.permissions.map(permission => permission.group)))];
		for (let distinctGroup of distinctGroups) {
			this.sections.push({ label: distinctGroup, wrappers: this.parse(input, distinctGroup) })
		}
		// this.memberPermissions = this.parse(input, 'Member');
		// this.agentPermissions = this.parse(input, 'Agent');
		// this.ticketPermissions = this.parse(input, 'Ticket');
		// this.communicationPermissions = this.parse(input, 'Communication');
		// this.entityPermissions = this.parse(input, 'Entity');
		// this.configurationPermissions = this.parse(input, 'Configuration');

		// this.bankDepositPermissions = this.parse(input,'BankDeposit');
		// this.policyPermissions = this.parse(input,'Policy');
		// this.productPermissions = this.parse(input,'Product');
		// this.bulkUploadPermissions = this.parse(input,'BulkUpload');
		// this.verificationPermissions = this.parse(input,'Verification');
		// this.notificationTemplatePermissions = this.parse(input,'NotificationTemplate');

		// input.
		// this.sections = [
		// 	{label:'Agent',wrappers:this.agentPermissions},
		// 	{label:'Member',wrappers:this.memberPermissions},
		// 	{label:'Bulk Upload',wrappers:this.bulkUploadPermissions},
		// 	{label:'Verification',wrappers:this.verificationPermissions},
		// 	{label:'Entity',wrappers:this.entityPermissions},
		// 	{label:'Ticket',wrappers:this.ticketPermissions},
		// 	{label:'Communication',wrappers:this.communicationPermissions},
		// 	{label:'Notification Template',wrappers:this.notificationTemplatePermissions},
		// 	{label:'Product',wrappers:this.productPermissions},
		// 	{label:'Policy',wrappers:this.policyPermissions},
		// 	{label:'Bank Deposit',wrappers:this.bankDepositPermissions},
		// 	{label:'Configuration',wrappers:this.configurationPermissions}
		// ];
	}
	private parse(input: AppRoleDto[], filter: RolePermissionGroupEnum): PermissionWrapper[] {
		const uniquePermissions: PermissionDto[] = [];
		input.forEach(role => {
			role.permissions.filter(p => !filter || p.group === filter).forEach(p => {
				if (uniquePermissions.filter(i => i.permission == p.permission).length == 0) {
					uniquePermissions.push(p);
				}
			});
		});
		return uniquePermissions.map(item => {
			return {
				label: item.label,
				permission: item.permission,
				description: item.description,
				roles: input.map(i => {
					return {
						roleId: i.id,
						selected: i.permissions.filter(j => j.selected == true).filter(j => j.permission == item.permission).length != 0
					};
				})
			};
		});
	}
	doSubmit() {
		const tmp = JSON.stringify(this.appRoles);
		const payload: AppRoleDto[] = JSON.parse(tmp);
		payload.forEach(item => {
			item.permissions = [];
		});

		const allPermissions = this.sections
			.flatMap(section => section.wrappers)
			.forEach(permissionWrapper => {
			permissionWrapper.roles.filter(item => item.selected == true).forEach(roleWrapper => {
				payload.filter(item => item.id == roleWrapper.roleId).forEach(appRole => {
					appRole.permissions.push({
						group: 'Configuration',
						label: permissionWrapper.label,
						permission: permissionWrapper.permission,
						selected: true,
						hashCode: 0
					});
				})
			});
		});


		this.service.savePermissions(payload).subscribe(result => {
			this.populate(result);
			this.messageService.info("Permissions Saved");
		});
	}

	areAllSelected(input: PermissionWrapper[], roleId: number) {
		return !input.map(item => item.roles).flat().filter(i => i.roleId == roleId).some(item => item.selected == false);
	}
	areSomeSelected(input: PermissionWrapper[], roleId: number) {
		if (this.areAllSelected(input, roleId)) {
			return false;
		}
		return input.map(item => item.roles).flat().filter(i => i.roleId == roleId).some(item => item.selected == true);
	}
	setMultipleSelected(input: PermissionWrapper[], roleId: number, selected: boolean) {
		return input.map(item => item.roles).flat().filter(i => i.roleId == roleId).forEach(item => item.selected = selected);
	}

	trackByPermission(index: number, item: PermissionWrapper): any {
		return item.permission;
	}
	trackByRole(index: number, item: RoleWrapper): any {
		return item.roleId;
	}
}
